import { L } from '@lib';
import { Tag } from 'antd';

export const LocalizedStatementStatus = {
  Unpaid: L('Unpaid'),
  Paid: L('Paid'),
};

const tagStyle = { minWidth: 100, textAlign: 'center' as const };

export const StatementStatusTag = {
  Unpaid: <Tag color="orange" style={tagStyle}>Unpaid</Tag>,
  Paid: <Tag color="green" style={tagStyle}>Paid</Tag>,
};

export type StatementStatusTagObjectKey = keyof typeof StatementStatusTag;
export type LocalizedStatementStatusObjectKey = keyof typeof LocalizedStatementStatus;
